<template>
  <v-dialog
    v-model="dialog.isOpen"
    :max-width="dialog.options.width"
    width="95%"
    :style="{ zIndex: dialog.options.zIndex }"
    @keydown.esc="dialog.cancel"
  >
    <v-card>
      <v-toolbar
        dark
        :color="dialog.options.color"
        dense
        flat
      >
        <v-toolbar-title class="white--text">
          {{ dialog.title }}
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text v-show="!!dialog.message" class="pa-4 py-10">
        {{ dialog.message }}
      </v-card-text>
      <v-divider />
      <v-card-actions class="pt-2">
        <v-spacer />
        <v-btn color="grey" variant="outlined" @click="dialog.cancel">
          Cancelar
        </v-btn>
        <v-btn color="primary darken-1" variant="outlined" @click="dialog.agree">
          Confirmar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useDialog } from '../stores/dialog'

export default defineComponent({
  data() {
    return {
      dialog: useDialog(),
    }
  },
})
</script>
